export default ":host {\n  z-index: 1;\n}"